<template>
  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" :width="size" :height="height" viewBox="0 0 54 14">
    <g :fill="fill">
      <circle class="st0" cx="7" cy="7" r="6">
        <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.1"/>
      </circle>
      <circle class="st0" cx="27" cy="7" r="6">
        <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.2"/>
      </circle>
      <circle class="st0" cx="47" cy="7" r="6">
        <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.3"/>
      </circle>
    </g>
  </svg>
</template>

<script>
// https://codepen.io/nikhil8krishnan/pen/rVoXJa
export default {
  name: "Loader4",
  props: {
    title: {
      default: 'Enregistrement',
      type: String,
    },
    fill: {
      default: 'currentcolor',
      type: String,
    },
    size: {
      type: Number,
      default: 24,
    },
  },
  computed: {
    height() {
      return this.size / (54 / 14); // viewBox ratio
    },
  },
}
</script>
